<template>
	<card title="Alert">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-list" v-for="item in collection" :key="item.id">
				<div class="sk-group-list-item" @click="onAlert_ClickHandler(item)">
					<div class="sk-group-list-item-value">
						<span>{{ getWarningName(item) }}</span>
					</div>
					<div class="sk-group-list-item-hour"><i class="sk-icon sk-icon-small sk-icon-hour"></i> {{ timePass(item) }}</div>
				</div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<!-- <template v-slot:more-options>
			<a href="#"><span>Clean all</span></a>
			<a href="#"><span>Historic</span></a>
		</template> -->
	</card>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-warnings',
	components: {
		Card
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	computed: {
		hasData: function() {
			return this.collection.length > 0
		},
		collection() {
			return this.getCollection(this.patient)
		},
		...mapGetters({
			currentUser: 'CURRENT_USER',
			getCollection: 'PATIENTS_ALERTS'
		}),
	},
// const TYPE_HEART_RATE       = 1
// const TYPE_BLOOD_PRESSURE   = 2
// const TYPE_TEMPERATURE      = 3
// const TYPE_BLOOD_SATURATION = 4
// const TYPE_GEOFENCING       = 5
// const TYPE_CALORIES         = 6
// const TYPE_PEDOMETER        = 7
// const TYPE_FALLS            = 8
// const TYPE_WEIGHT           = 9
// const TYPE_LOGS             = 10

	methods: {
		getName(id) {
			if (id == 1) return 'heart rate'
			else if (id == 2) return 'blood pressure'
			else if (id == 3) return 'temperature'
			else if (id == 4) return 'blood saturation'
			else if (id == 5) return 'geofencing'
			else if (id == 6) return 'calories'
			else if (id == 7) return 'pedometer'
			else if (id == 8) return 'fall'
			else if (id == 9) return 'weight'
			return 'logs'
		},
		getWarningName(value) {
			const type = value.type_reading_id

			if (type == 1) {
				return this.$t('Attention Unusual Heart Rate')
			} else if (type == 2) {
				return this.$t('Attention Unusual Blood Pressure')
			} else if (type == 3) {
				return this.$t('Attention Unusual Temperature')
			} else if (type == 4) {
				return this.$t('Attention Unusual Blood Oxygen Level')
			} else if (type == 5) {
				return this.$t('Attention Patient Has Left The Safe Area')
			} else if (type == 6) {
				return this.$t('Attention Was Not Achieved Daily Calorie Goals')
			} else if (type == 7) {
				return this.$t('Attention Was Not Achieved The Goals Of Daily Steps')
			} else if (type == 8) {
				return this.$t('Attention Fall Detected')
			}

			return this.$t(value.name)
		},
		onAlert_ClickHandler(value) {
			const type = value.type_reading_id
			let routeName = 'WatchBiometricView'
			let params = {}

			if (type == 1) {
				params = {
					type: 'heart-rate'
				}
			} else if (type == 2) {
				params = {
					type: 'blood-pressure'
				}
			} else if (type == 3) {
				params = {
					type: 'temperature'
				}
			} else if (type == 4) {
				params = {
					type: 'blood-saturation'
				}
			} else if (type == 5) {
				routeName = 'WatchGeofencing'
			} else if (type == 6) {
				params = {
					type: 'calories'
				}
			} else if (type == 7) {
				params = {
					type: 'pedometer'
				}
			} else if (type == 8) {
				params = {
					type: 'falls'
				}
			} else if (type == 10) {
				this.requestCloseAlert(value)
				return
			} else {
				return
			}

			this.$router.push({
				name: routeName,
				params: {
					user_uid: this.currentUser.uid,
					watch_id: this.patient.id,
					...params
				}
			})
		},
		timePass: (value) => moment(value.date).fromNow(),
		requestCloseAlert(alert) {
			this.$appModal.show({
				icon: true,
				buttons: 2,
				title: this.$t('Attention'),
				message: this.$t('Do you want to close the alert?'),
				buttonsLabels: {
					ok: this.$t(`Yes, close`),
					cancel: this.$t(`No`)
				},
				onOK: () => {
					this.closeAlert(alert)
				}
			})
		},
		async closeAlert(alert) {
			const refThis = this
			const user = this.currentUser
			const patient = this.patient
			try {
				await this.$store.dispatch('ALERT_POST_AUTO_REPORT_CLOSE', { refThis, user, patient, alert })
				this.$appToast.show({
					type: 'success',
					title: 'Success',
					message: 'Alert closed.'
				})
			} catch (ex) {
				this.$appToast.show({
					type: 'error',
					title: 'Error',
					message: 'Issue close alert.'
				})
			}
		}
	}
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientWarnings.vue